import getClosestReferenceId from './get-closest-reference-id';
import getLiveElement from './get-live-element';
import getParentLiveElement from './get-parent-live-element';
import getParentLiveElementId from './get-parent-live-element-id';
import getStaticElement from './get-static-element';
import getNodesByPresenceSetting from './get-nodes-by-presence-setting';
import getMappedHTML from './get-mapped-html';
import getElementAttribute from './get-element-attribute';
import getLiveElementByCoords from './get-live-element-by-coords';
import getLiveDocument from './get-live-document';
import getSelection from './get-selection';
import getLiveElementLastChild from './get-live-element-last-child';
import getLiveElementByStaticElement from './get-live-element-by-static-element';
import getInlineElementStyle from './get-inline-element-style';
import getElementStyles from './get-element-styles';
import getReferenceIdByStaticElement from './get-reference-id-by-static-element';
import getStaticDocument from './get-static-document';

export default {
  getClosestReferenceId,
  getLiveElement,
  getParentLiveElement,
  getParentLiveElementId,
  getStaticElement,
  getNodesByPresenceSetting,
  getMappedHTML,
  getElementAttribute,
  getLiveElementByCoords,
  getLiveDocument,
  getSelection,
  getLiveElementLastChild,
  getLiveElementByStaticElement,
  getInlineElementStyle,
  getElementStyles,
  getReferenceIdByStaticElement,
  getStaticDocument,
};
